export interface ISpinner {
  isLoading: boolean;
}

import Default from "./Default";
import Small from "./Small";
import AutoWithRedux from "./SpinnerContainer";

export default { Default, Small, AutoWithRedux };
